<div class="h-full! px-2 py-8">
  <form [formGroup]="form" (submit)="onSubmit()" class="h-full flex flex-col justify-between px-2">
    <div class="h-[65vh] w-full overflow-y-auto px-4 md:h-[76vh] xl:h-[80vh]">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2 pb-6">
          <p class="text-lg font-semibold not-italic leading-[normal]" translate>trilhas.estudio.trilha.titulo</p>
        </div>
        <app-form-field>
          <label app-label translate>trilhas.evento.publicado</label>
          <app-switch formControlName="status"></app-switch>
        </app-form-field>
      </div>

      <app-form-field class="w-full" [required]="true">
        <label class="text-[14px]!" app-label translate>trilhas.imagem</label>
        <app-upload-file
          [config]="config"
          [image]="thumbnail$ | async"
          [invalid]="submitted && form.controls.thumbnail.invalid"
          (statusChange)="onUpload($event)"
        ></app-upload-file>
        <span app-error *ngIf="submitted && form.controls.thumbnail.invalid" translate>geral.erros.required</span>
      </app-form-field>

      <app-form-field>
        <label class="flex text-[14px]!" app-label translate
          >trilhas.estudio.tipo-visualizacao.tipo
          <svg-icon
            app-tooltip
            [tooltip]="msgTypeView"
            class="ml-2 h-5 w-5 text-theme-800"
            src="assets/icons/icon-question.svg"
          ></svg-icon>
        </label>
        <ng-select
          app-select
          formControlName="tipo"
          [placeholder]="'trilhas.estudio.tipo-visualizacao.selecione' | translate"
          [clearable]="false"
        >
          <ng-option [value]="0" translate>trilhas.estudio.tipo-visualizacao.linear-nao-guiado</ng-option>
          <ng-option [value]="1" translate>trilhas.estudio.tipo-visualizacao.linear-guiado</ng-option>
          <ng-option *ngIf="form.get('tipo').value === 2" [value]="2" translate
            >trilhas.estudio.tipo-visualizacao.agrupado</ng-option
          >
        </ng-select>
      </app-form-field>
      <app-form-field>
        <label class="!text-[14px]" app-label translate>trilhas.estudio.titulo</label>
        <input app-input formControlName="titulo" [placeholder]="'trilhas.estudio.titulo' | translate" />
      </app-form-field>
      <app-form-field>
        <label class="!text-[14px]" app-label translate>trilhas.estudio.trilha.carga-horaria</label>
        <div class="flex">
          <input
            type="number"
            class="rounded-e-none"
            app-input
            maxLength="20"
            [min]="0"
            [placeholder]="'trilhas.estudio.trilha.registrar-carga-horaria' | translate"
            formControlName="carga_horaria"
          />
          <span
            app-input-suffix
            class="rounded-s-0 border-e-none inline-flex items-center rounded-e-md border border-gray-300 bg-gray-200 px-3 text-sm text-gray-900"
            translate
          >
            trilhas.estudio.trilha.horas
          </span>
        </div>
      </app-form-field>
      <app-form-field>
        <label class="!text-[14px]" app-label translate>trilhas.estudio.trilha.conteudo</label>
        <app-text-editor formControlName="descricao" [url]="ckeditorUploadImageUrl"></app-text-editor>
      </app-form-field>
    </div>
    <div class="flex w-full items-center justify-between gap-3 px-4">
      <button
        app-outline-button
        class="!h-10 w-1/2 border-base-status-danger text-base-status-danger hover:[&:not([disabled])]:bg-base-status-danger hover:[&:not([disabled])]:text-theme-contrast"
        type="button"
        (click)="onClose()"
      >
        <span class="font-medium uppercase" translate>geral.cancelar</span>
      </button>
      <button
        app-outline-button
        class="w-1/2 border-theme-500 text-theme-500 hover:[&:not([disabled])]:bg-theme-500 hover:[&:not([disabled])]:text-theme-contrast"
        type="submit"
      >
        <span class="font-medium uppercase" translate>geral.salvar</span>
      </button>
    </div>
    <div *ngIf="!(learningTrailsSectionService.sections$ | async)?.length && form.value.id" class="px-4 py-4">
      <button
        app-outline-button
        class="!h-10 w-full border-base-status-danger text-base-status-danger hover:[&:not([disabled])]:bg-base-status-danger hover:[&:not([disabled])]:text-theme-contrast"
        type="button"
        (click)="onDelete()"
      >
        <span class="font-medium uppercase" translate>geral.excluir</span>
      </button>
    </div>
  </form>
</div>
